<template>
    <div id="facts">

        <div id="top-overlay">
            <img src="../../assets/imgs/general/overlay-shape.png" alt="" class="w-100">
        </div>

        <div id="facts-carousel" class="text-center">
            <div class="item" v-for="(fact, index) in facts" v-bind:key="index">
                <div :class="'d-flex flex-column flex-sm-row justify-content-between justify-content-md-around text-center py-5 background-item background-' +  index%3">

                    <div class="d-flex flex-row w-md-25">

                        <div class="p-3 pt-lg-5 ml-lg-3 mt-lg-5" id="dintica-carousel-container">
                            <img src="../../assets/imgs/facts/dintica_jetpack.png" alt=""
                                 class="img-fluid dintica-carousel">
                        </div>

                        <div class="p-3 d-block d-sm-none" id="nava-carousel-container">
                            <img src="../../assets/imgs/landing/hero-nava.png" alt="" class="img-fluid nava-carousel">
                        </div>

                    </div>

                    <div class="d-flex flex-column my-auto w-md-50 px-3 pl-sm-0 pr-sm-5 pr-md-3 pr-lg-0" id="text-carousel">
                        <h4 class="mt-sm-5">Știai că...</h4>
                        <h5 class="pb-5 py-sm-3 w-md-75 text-center mx-auto" v-text="fact.text"></h5>
                    </div>

                    <div class="p-3 mr-lg-3 mt-lg-5 w-md-25 d-none d-sm-block" id="nava-carousel-container">
                        <img src="../../assets/imgs/landing/hero-nava.png" alt="" class="img-fluid nava-carousel">
                    </div>

                </div>
            </div>
        </div>

        <div id="bottom-overlay">
            <img src="../../assets/imgs/general/overlay-shape.png" alt="" class="w-100">
        </div>

    </div>
</template>

<script>

    import anime from 'animejs/lib/anime.js';


    export default {
        name: "Facts",
        data() {
            return {
                facts: [
                    {
                        "text": "Periuțele de dinți pot avea peri moi, tari sau medii. Pentru copii sunt recomandate cele moi.",
                    },
                    {
                        "text": "Smalțul dinților este cea mai dură substanță din corpul uman. E ca un scut care ne protejează de bacteriile care cauzează carii.",
                    },
                    {
                        "text": "Spre deosebire de oase, dinții nu se pot repara singuri. De aceea trebuie să avem mare grijă de ei!",
                    },
                    {
                        "text": "Cei mai mari dinți din gură sunt molarii (cunoscuți și ca măsele).",
                    },
                    {
                        "text": "Este bine să te speli pe dinți timp de două minute întregi.",
                    },
                    {
                        "text": "Sucul acidulat atacă dinții, chiar și când nu are zahăr, ci doar îndulcitor.",
                    },
                    {
                        "text": "Periuța de dinți cu perișori a fost inventată în China în jurul anului 1498.",
                    },
                    {
                        "text": "Cel mai bun mod de a te spăla pe dinți este prin mișcări în formă de cerc.",
                    },
                    {
                        "text": "În general, copiii au 20 de dinți de lapte. Când cresc mari vor avea 32 de dinți!",
                    }
                ]
            }
        },
        mounted() {
            const $ = window.$;
            let carousel = $('#facts-carousel');

            $(function () {

                carousel.slick({
                    dots: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    cssEase: 'linear',
                    fade: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                });

                anime({
                    targets: '.dintica-carousel',
                    direction: 'alternate',
                    translateY: [25, -25],
                    translateX: 10,
                    duration: 4000,
                    easing: 'linear',
                    loop: true
                });

                anime({
                    targets: '.nava-carousel',
                    direction: 'alternate',
                    translateY: [30, 10],
                    translateX: 20,
                    duration: 5000,
                    easing: 'linear',
                    loop: true
                });
            })
        }
    }
</script>
